import { createOptionsFrom } from "@/lib/common/Option";

export const EvProductTypeLabels = {
	All: "All Product Types",
	Pack: "Packs",
	Box: "Boxes",
	Case: "Cases"
} as const;

export type EvProductType = keyof typeof EvProductTypeLabels;

export const EvProductTypeOptions = createOptionsFrom(EvProductTypeLabels);
